import React from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import styles from './styles.module.scss';

export function AccessRule({ accessRule }) {

  const { selected, updateSelected, updateAdding } = useAccessManagement2NModal();
  const accessRuleId = accessRule && (accessRule.Id || accessRule.id);
  const selectedAccessRuleId = selected.accessRule && selected.accessRule.Id;
  const accessRuleName = (accessRule && accessRule.Name) || '';

  const onAccessRuleClick = () => {
    updateSelected('accessRule', accessRule);
    updateAdding('accessRule', false);
  };

  return (
    <div
      className={styles.accessRuleCard}
      onClick={onAccessRuleClick}
    >
      <div className={styles.details}>
        <Text
          size={14}
          uppercase
        >
          {accessRuleName}
        </Text>
      </div>

      <ShouldRender condition={!!selected.accessRule && selectedAccessRuleId === accessRuleId}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
}

